"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToastMessage = void 0;
var React = __importStar(require("react"));
var mdbreact_1 = require("@aon/mdbreact");
var ToastContent_1 = require("./ToastContent");
var ToastMessage = /** @class */ (function (_super) {
    __extends(ToastMessage, _super);
    function ToastMessage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._toastId = undefined;
        _this.renderToast = function () {
            if (_this.toastId === undefined) {
                _this.initialize();
            }
            else {
                _this.update();
            }
        };
        return _this;
    }
    Object.defineProperty(ToastMessage.prototype, "toastId", {
        get: function () {
            return this._toastId;
        },
        enumerable: false,
        configurable: true
    });
    ToastMessage.prototype.componentDidMount = function () {
        this.renderToast();
    };
    ToastMessage.prototype.componentDidUpdate = function () {
        this.renderToast();
    };
    ToastMessage.prototype.componentWillUnmount = function () {
        if (this.toastId !== undefined) {
            mdbreact_1.toast.dismiss(this.toastId);
        }
    };
    ToastMessage.prototype.render = function () {
        return React.createElement(React.Fragment, null);
    };
    ToastMessage.prototype.initialize = function () {
        var _this = this;
        // This is supposed to re-use one global container, rather than each toast having own ToastContainer.
        this._toastId = (0, mdbreact_1.toast)(React.createElement(ToastContent_1.ToastContent, __assign({}, this.props)), __assign(__assign({}, this.props), { onClose: function () {
                var _a, _b;
                // Clear out the toast Id
                _this._toastId = undefined;
                // Invoke parent handler
                (_b = (_a = _this.props).onClose) === null || _b === void 0 ? void 0 : _b.call(_a);
            } }));
        // E.g. two top-right ToastContainer created by two <Toast.../> look to overlap the toasts msgs, etc.
        // https://github.com/fkhadra/react-toastify for more info.
    };
    ToastMessage.prototype.update = function () {
        mdbreact_1.toast.update(this.toastId, { render: React.createElement(ToastContent_1.ToastContent, __assign({}, this.props)) });
    };
    ToastMessage.defaultProps = {
        iconSize: 'md',
        pauseOnHover: false,
    };
    return ToastMessage;
}(React.Component));
exports.ToastMessage = ToastMessage;
